<div class="email-verification-container">
  <div class="email-verification-container-overlay"></div>
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="email-verify email-verified text-center">
          <div style="border-radius:200px; height:200px; width:200px; background: #F8FAF5; margin:0 auto;" class="email-verified">
            <i class="checkmark">✓</i>
          </div>
          <h1 class="email-verified">Success</h1>
          <p>We have sent you an email. Please follow the instructions</p>
        </div>
      </div>
    </div>
  </div>
</div>
